import { useGetProviderIconUrl } from '../hooks/use-get-provider-icon-url'
import type { BaseIconProps } from './base-provider-icon'
import { BaseProviderIcon } from './base-provider-icon'

export const GeotabIcon = ({ size }: BaseIconProps) => {
  const iconUrl = useGetProviderIconUrl('geotab-logo', 'logo')

  return <BaseProviderIcon size={size} src={iconUrl} label="geotab-icon" />
}
